<template>
  <div class="componente-completo" ref="containerRef">
    <div class="rasgado rasgado-top"></div>

    <!-- 🌸 FLORES IZQUIERDA -->
    <img src="@/assets/floor.png" class="flores izquierda" alt="" />

    <!-- 🌸 FLORES DERECHasasA -->
    <img src="@/assets/floor.png" class="flores derecha" alt="" />

    <!-- BOLA -->
    <img ref="bolaRef" src="@/assets/floor.png" alt="Bola de disco" class="bola-disco" />

    <!-- ESTRELLAS -->

    <!-- FOTO 1 -->
    <img 
      ref="fotoRef" 
      src="@/assets/4W8A1542.webp" 
      alt="Foto destacada" 
      class="foto-elegante" 
    />

    <!-- FOTO 2 -->
    <img 
      ref="foto2Ref" 
      src="@/assets/4W8A1712.webp" 
      alt="Foto secundaria" 
      class="foto-elegante-reversa" 
    />

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import gsap from 'gsap';

export default {
  name: 'ComponenteCompleto',
  setup() {
    const containerRef = ref(null);
    const fotoRef = ref(null);
    const foto2Ref = ref(null);
    const bolaRef = ref(null);
    const estrellasRef = ref(null);

    const animate = () => {
      const tl = gsap.timeline({
        defaults: { ease: 'power3.out' }
      });

      // CONTENEDOR
      tl.fromTo(containerRef.value,
        { opacity: 0, y: 60, scale: 0.96 },
        { opacity: 1, y: 0, scale: 1, duration: 1.1 }
      );

      // FOTO 1 (RECTA)
      if (fotoRef.value) {
        tl.fromTo(fotoRef.value,
          { opacity: 0, y: 80, scale: 0.9 },
          { opacity: 1, y: 0, scale: 1, duration: 1.2 },
          '-=0.8'
        );
      }

      // FOTO 2 (RECTA)
      if (foto2Ref.value) {
        tl.fromTo(foto2Ref.value,
          { opacity: 0, y: 70, scale: 0.9 },
          { opacity: 1, y: 0, scale: 1, duration: 1.1 },
          '-=1'
        );
      }

      // BOLA
      if (bolaRef.value) {
        tl.fromTo(bolaRef.value,
          { opacity: 0, y: -140, scale: 0.5 },
          { opacity: 1, y: 0, scale: 1, duration: 1 },
          '-=1'
        );

        gsap.to(bolaRef.value, {
          y: '+=10',
          duration: 2.4,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        });
      }

      // ESTRELLAS
      if (estrellasRef.value) {
        tl.fromTo(estrellasRef.value,
          { opacity: 0, y: -40 },
          { opacity: 1, y: 0, duration: 1 },
          '-=0.9'
        );

        gsap.to(estrellasRef.value, {
          opacity: 0.4,
          duration: 1.5,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        });
      }
    };

    onMounted(() => {
      const observer = new IntersectionObserver(
        ([entry], obs) => {
          if (entry.isIntersecting) {
            animate();
            obs.unobserve(entry.target);
          }
        },
        { threshold: 0.3 }
      );

      if (containerRef.value) observer.observe(containerRef.value);
    });

    return {
      containerRef,
      fotoRef,
      foto2Ref,
      bolaRef,
      estrellasRef
    };
  }
};
</script>

<style scoped>
.componente-completo {
  position: relative;
  width: 100%;
  padding: 0px 0 160px;
  display: flex;
  background-color: #8fbbdf;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  margin-top: -0px;
}

/* 🌸 FLORES */
.flores {
  position: absolute;
  width: 140px;
  opacity: 0.9;
      margin-top:-80px !important;

  z-index: 0;
}

.flores.izquierda {
  left: -20px;
  bottom: 0;
  margin-top:-80px !important;
}

.flores.derecha {
  right: -80px;
  bottom: 0;

}

/* RASGADOS */
.rasgado {
  position: absolute;
  left: 0;
  background-color: #ffffff;
  width: 100%;
  height: 40px;
  z-index: 3;
  pointer-events: none;
}

.rasgado-top {
  top: 0;
 background-image: 
    linear-gradient(rgba(255, 255, 255, 0.73), rgba(255, 255, 255, 0.85)),
    url('@/assets/ff.jpg');

  background-size:cover;
  background-position:center;
  background-repeat:no-repeat; clip-path: polygon(
    0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%
  );
}

/* FOTO */
.foto-elegante,
.foto-elegante-reversa {
  width: 470px;
  max-width: 90%;
  border-radius: 10px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
  opacity: 0;
  margin: 90px 0;
  margin-bottom: 15px;
  transform: none !important; /* 🔥 SIN ROTACIÓN */
}

.foto-elegante {
  z-index: 2;
}

.foto-elegante-reversa {
  z-index: 1;
  margin-top: 0px; /* overlap bonito */
}

/* BOLA */
.bola-disco {
  width: 120px;
  opacity: 0;
  z-index: 3;
      margin-top:-80px !important;

  margin-right: -180px;
  margin-bottom: -30px;
}

/* ESTRELLAS */
.estrellas-decorativas {
  width: 100px;
  position: absolute;
  bottom: 30px;
  right: 30px;
      margin-top:-80px !important;

  opacity: 0;
}
</style>